import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { CategoriaService } from '../../services/categoria.service';
import { Categoria } from '../../model/categoria';

import { SubcategoriaService } from '../../services/subcategoria.service';
import { Subcategoria } from '../../model/subcategoria';

import { Consorcio } from '../../model/consorcio';


@Component({
  selector: 'app-subcategoria-articulo-mantenimiento',
  templateUrl: './subcategoria-articulo-mantenimiento.component.html',
  styleUrls: ['./subcategoria-articulo-mantenimiento.component.css']
})
export class SubcategoriaArticuloMantenimientoComponent implements OnInit {

  @Input() subCategoriaSeleccionada: Subcategoria;
  @Input() consorcio: Consorcio;
  @Input() categoria: string;
  @Output() onReturn = new EventEmitter();


  public categorias: Categoria[];
  public subCategoria: Subcategoria = new Subcategoria();
  public estadoBorrar: boolean = false;
  public estadoEditar: boolean = false;

  public errorMessage: any;

  constructor(
    private _subCategoriaService: SubcategoriaService,
    private _categoriaService: CategoriaService,
  ) { }


  ngOnInit() {
     if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    if (this.subCategoriaSeleccionada != null) {
      this.subCategoria = this.subCategoriaSeleccionada;
      this.estadoEditar = true;
    }
    this.subCategoria.codigoCategoria = this.categoria;
    this.cargarCategorias();

  }

  cargarCategorias() {
    if (this.consorcio === null) {
      return;
    }
    this._categoriaService.getCategorias(this.consorcio)
      .subscribe(
      data => this.categorias = data,
      err => {
        console.clear();
        console.log(err._body);
      });
  }

  onSubmit() {
    if (this.subCategoria.id === undefined) {
      this.subCategoria.id = 0;
    }
    this.subCategoria.codigoConsorcio = this.consorcio.codigoConsorcio;
    this._subCategoriaService.insert(this.subCategoria).subscribe(
      result => { 
        if(result.Resultado === "codigoSubCategoria ya existe en la base de datos"){
            alert("El código de la SubCategoría ya existe");
        }else{
          if(result.Resultado === false){
            alert("Ha ocurrido un error...");  
          }else{
            this.onSubmitSuccess(result);
          }
        }
      }
	  
	  ,
      err => {
        console.log(err._body);
      });
  }

  onSubmitSuccess(data: any) {
    this.regresar();
  }

  regresar() {
    this.onReturn.emit();
  }

  solicitaBorrar() {
    this.estadoBorrar = true;
  }

  solicitudBorrarCancelar() {
    this.estadoBorrar = false;
  }

  borrarRegistro() {
    this._subCategoriaService.delete(this.subCategoria).subscribe(
      result => this.regresar(),
      err => {
        console.log(err);
      });

  }

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/subcategoria-articulo-mantenimiento/subcategoria-articulo-mantenimiento.component.ts